import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { DatasourceDownstreamLensesQueryVariables, DatasourceDownstreamLensesQuery, LensesDisplayGridRowDataFragment, DatasourceDownstreamLensesFilteredByFieldQueryVariables, DatasourceDownstreamLensesFilteredByFieldQuery, LensSortOrder , DatasourceDownstreamLensesFilteredByFieldDocument , DatasourceDownstreamLensesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { getRowDataForLens, LensesDisplayGrid, LensesDisplayGridRowData } from '../sharedDisplayGrid/LensesDisplayGrid';
import { LensesValidSortFields } from '../sorting/sortProviders/LensesGridSortProvider';

type QueryVariables = DatasourceDownstreamLensesQueryVariables;
type QueryResults = DatasourceDownstreamLensesQuery;
type QueryResultListNode = LensesDisplayGridRowDataFragment;
type GridRowData = LensesDisplayGridRowData;

type QueryVariablesWithFilter = DatasourceDownstreamLensesFilteredByFieldQueryVariables;
type QueryResultsWithFilter = DatasourceDownstreamLensesFilteredByFieldQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.publishedDatasources && resultData.publishedDatasources[0]?.downstreamLensesConnection;
}

function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter):
  ConnectionListResult<QueryResultListNode> | null {
  return resultData?.fieldsConnection?.nodes &&
    resultData.fieldsConnection.nodes[0]?.downstreamLensesConnection;
}


export type DatasourceDownstreamLensesQueryGridProps =
  GridSortProps<LensesValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredFieldId: string | null;
    readonly rowCount: number | null;
  };

export function DatasourceDownstreamLensesQueryGrid(props: DatasourceDownstreamLensesQueryGridProps): JSX.Element {

  const emptyGridMessage = Messages.EmptyDownstreamLensesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredLensesLineageGridMessage();

  return props.filteredFieldId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={DatasourceDownstreamLensesFilteredByFieldDocument}
      partialQueryVariables={{
        selectedFieldId: props.filteredFieldId,
        orderBy: props.orderBy as LensSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) =>
        <LensesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={DatasourceDownstreamLensesDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as LensSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) =>
        <LensesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
}
